<template>
  <div class="box2">
    <pageTitle
      title="国际学历提升<br/>助您在职场竞争中脱颖而出"
      
    />

    <div class="subject-box">
     <img src="../../../assets/coursePage/nau/box2/img01.png"/>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  data() {
    return {
 
    };
  },
};
</script>

<style lang="less" scoped>
.box2 {
  padding: 80px 0 80px;
  width: 100%;
  background: #EAF3FD; 
  .subject-box {
    padding: 48px 32px 0;
    img{
      width: 100%;
    }
  }

  
}
</style>
